export const PERCENTAGE_DELTA_MIN = -100;
export const PERCENTAGE_DELTA_MAX = 100;
export const PERCENTAGE_DELTA_STEP = 2.5;

export const clampPercentageDelta = (value: number): number => {
  if (Number.isNaN(value)) return 0;
  return Math.min(PERCENTAGE_DELTA_MAX, Math.max(PERCENTAGE_DELTA_MIN, value));
};

export const applyPercentageDelta = (
  pence: number,
  percentageDelta: number,
): number => {
  const clamped = clampPercentageDelta(percentageDelta);
  const adjusted = pence * (1 + clamped / 100);
  return Math.max(0, Math.round(adjusted));
};
